<template>
  <v-card elevation="0" class="pa-2" v-if="courseGroup && courseGroup.id">
    <v-card-title class="mb-3">
      <h3><strong>Turma</strong></h3>
    </v-card-title>

    <v-row cols="12" class="ma-0 mt-2">
      <v-divider></v-divider>
    </v-row>

    <v-row cols="12" class="ma-0 mt-2">
      <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
        <strong>Curso: </strong>
        <span>{{ courseGroup.course.name }}</span>
      </v-col>
    </v-row>

    <v-row cols="12" class="ma-0 mt-2">
      <v-divider></v-divider>
    </v-row>

    <v-row cols="12" class="ma-0 mt-2">
      <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
        <strong>Local: </strong>
        <span>{{ courseGroup.local }}</span>
      </v-col>
    </v-row>

    <v-row cols="12" class="ma-0 mt-2">
      <v-divider></v-divider>
    </v-row>

    <v-row cols="12" class="ma-0 mt-2">
      <v-col cols="12" xs="12" sm="12" md="12" lg="4" xl="4">
        <strong>Horário de início: </strong>
        <span>{{ courseGroup.startTime }}</span>
      </v-col>

      <v-col cols="12" xs="12" sm="12" md="12" lg="4" xl="4">
        <strong>Hora de término: </strong>
        <span>{{ courseGroup.endTime }}</span>
      </v-col>

      <v-col cols="12" xs="12" sm="12" md="12" lg="4" xl="4">
        <strong>Data de início: </strong>
        <span>{{ formatDate(courseGroup.startDate) }}</span>
      </v-col>
    </v-row>

    <v-row cols="12" class="ma-0 mt-2">
      <v-divider></v-divider>
    </v-row>

    <v-row cols="12" class="ma-0">
      <v-col cols="12" xs="12" sm="12" md="12" lg="4" xl="4">
        <strong>Data de término: </strong>
        <span>{{ formatDate(courseGroup.endDate) }}</span>
      </v-col>

      <v-col cols="12" xs="12" sm="12" md="12" lg="4" xl="4">
        <strong>Data de início das inscrições: </strong>
        <span>{{ formatDate(courseGroup.startDateInscription) }}</span>
      </v-col>

      <v-col cols="12" xs="12" sm="12" md="12" lg="4" xl="4">
        <strong>Data de término das inscrições: </strong>
        <span>{{ formatDate(courseGroup.endDateInscription) }}</span>
      </v-col>
    </v-row>

    <v-row cols="12" class="ma-0 mt-2">
      <v-divider></v-divider>
    </v-row>


    <v-row cols="12" class="ma-0">
      <v-col cols="12" xs="12" sm="12" md="12" lg="4" xl="4">
        <strong>Período: </strong>
        <span>{{ formatPeriod(courseGroup.period) }}</span>
      </v-col>

      <v-col cols="12" xs="12" sm="12" md="12" lg="4" xl="4">
        <strong>Quantidade de vagas: </strong>
        <span>{{ courseGroup.numberOfVacancies }}</span>
      </v-col>

      <v-col cols="12" xs="12" sm="12" md="12" lg="4" xl="4">
        <strong>Ativo: </strong>
        <span>{{ courseGroup.active ? 'Sim' : 'Não' }}</span>
      </v-col>
    </v-row>

    <v-row cols="12" class="ma-0 mt-2">
      <v-divider></v-divider>
    </v-row>

    <v-row cols="12" class="ma-0">
      <v-col cols="12" xs="12" sm="12" md="12" lg="8" xl="8">
        <strong>Dias das aulas: </strong>
        <span>{{ formatDaysOfTheWeek(courseGroup.daysOfTheWeek) }}</span>
      </v-col>


      <v-col cols="12" xs="12" sm="12" md="12" lg="4" xl="4">
        <strong>Nível: </strong>
        <span>{{ formatLevel(courseGroup.level) }}</span>
      </v-col>
    </v-row>

    <v-row cols="12" class="ma-0 mt-2">
      <v-divider></v-divider>
    </v-row>



    <v-row class="ma-0">
      <v-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
        <v-btn
            elevation="0"
            class="secondary-button"
            width="100%"
            @click="close()"
        >
          <span>Fechar</span>
        </v-btn>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import ApiService from "../../../../services/ApiService";
import Utils from "../../../../Utils/FormatDate";
import Vue from "vue";
import UtilsFormatCurrency from "@/Utils/FormatCurrency";

export default {
  name: "DetailCourseGroup",
  components: {},
  computed: {},

  props: {
    courseGroupId: {type: Number, required: true, default: null}
  },

  created() {
  },

  async mounted() {
  },
  data() {
    return {
      courseGroup: Object,
      active: [
        {name: "Não", value: 'false'},
        {name: "Sim", value: true},
      ],
      periods: [
        {name: "Matutino", value: "0"},
        {name: "Vespertino", value: 1},
        {name: "Noturno", value: 2}
      ],
      levels: [
        {name: "Iniciante", value: "0"},
        {name: "Intermediário", value: 1},
        {name: "Avançado", value: 2}
      ],
      daysOfTheWeek: [
        {name: "Domingo", value: 0},
        {name: "Segunda-feira", value: 1},
        {name: "Terça-feira", value: 2},
        {name: "Quarta-feira", value: 3},
        {name: "Quinta-feira", value: 4},
        {name: "Sexta-feira", value: 5},
        {name: "Sábado", value: 6}
      ],
      apiService: new ApiService(),
      rules: {
        required: (value) => !!value || "Campo requerido.",
      }
    };
  },

  methods: {
    close() {
      this.$emit('close')
    },
    formatDaysOfTheWeek(daysOfTheWeek) {
      return this.daysOfTheWeek.filter(x => daysOfTheWeek.includes(x.value)).map(x => x.name).join(', ')
    },
    formatLevel(level) {
      return this.levels.find(x => x.value == level).name;
    },
    formatPeriod(period) {
      return this.periods.find(x => x.value == period).name;
    },
    formatDate(date) {
      return Utils.momentDay(date);
    },
    formatCurrency(value) {
      return UtilsFormatCurrency.formatCurrency(value);
    },
    async goToRoute() {
      await this.$router.push({
        path: `/cursos-cadastrar`,
        query: {courseGroupId: this.courseGroupId}
      });
    },
    async getCourseGroup() {
      try {
        const {content} = await this.apiService.get(`courseGroup/${this.courseGroupId}`,)
        this.courseGroup = content

      } catch (e) {

      }
    },
  },

  watch: {},
};
</script>

<style lang='scss' scoped>
#chartRecipeAndOrder {
  width: 100%;
}

#chartPaymentMethod {
  width: 100%;
}

.card-red {
  background: linear-gradient(to bottom, #f54784, #d62828);
  color: #fff;
  width: 100%;
  padding: 5px;
  border-radius: 10px;
  text-align: center;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);

  h3 {
    margin: 0;
    font-size: 16px;
    font-weight: normal;
  }

  p {
    margin: 10px 0 0;
    font-size: 20px;
    font-weight: bold;
  }
}

.card-black {
  background: linear-gradient(to bottom, #000000, #666666);
  color: #fff;
  width: 100%;
  padding: 5px;
  border-radius: 10px;
  text-align: center;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.3);

  h3 {
    margin: 0;
    font-size: 16px;
    font-weight: normal;
  }

  p {
    margin: 10px 0 0;
    font-size: 20px;
    font-weight: bold;
  }
}

table {
  width: 100%;
  border-collapse: collapse;
  margin-top: 20px;
}

th, td {
  padding: 10px 15px;
  text-align: left;
}

tr {
  cursor: pointer;
}

th {
  font-weight: bold;
  border-bottom: 2px solid #ddd;
}

/* coluna receita */
td.receita {
  background: linear-gradient(to right, #f8d7da, #f5c6cb);
  text-align: left;
  font-weight: bold;
  color: #333;
}

/* coluna metros */
td.metros {
  background: linear-gradient(to right, #f8d7da, #f1b0b7);
  text-align: left;
  font-weight: bold;
  color: #333;
}

tr:nth-child(even) td {
  background-color: #fafafa;
}

</style>
